import islandAerial from "@/assets/island-aerial.webp";
import islandAerialJpg from "@/assets/island-aerial.jpg";
import islandCabanas from "@/assets/blog-hero-island-cabanas.jpg";
import cabanaHammock from "@/assets/cabana-hammock.jpg";
import cabanaDock from "@/assets/cabana-dock-view.jpg";
import familyCabana from "@/assets/family-cabana.jpg";
import paddleHero from "@/assets/blog-hero-paddleboard.jpg";
import paddleSwim from "@/assets/paddleboarding-swimming.jpg";
import paddleGeronimo from "@/assets/sons-geronimo-paddleboard.jpg";
import kayaking from "@/assets/kayaking.jpg";
import kayakRiver from "@/assets/booking-sidebar-kayak-river.webp";
import kayakGeronimo from "@/assets/sons-geronimo-kayak-river.jpg";

export interface PopupImage {
  id: string;
  label: string;
  url: string;
}

export interface PopupImageGroup {
  group: string;
  images: PopupImage[];
}

export const POPUP_IMAGE_GROUPS: PopupImageGroup[] = [
  {
    group: "Cabana pictures",
    images: [
      { id: "cabana-hammock", label: "Cabana hammock", url: cabanaHammock },
      { id: "cabana-dock", label: "Cabana dock view", url: cabanaDock },
      { id: "cabana-family", label: "Family cabana", url: familyCabana },
    ],
  },
  {
    group: "Island pictures",
    images: [
      { id: "island-aerial-webp", label: "Island aerial", url: islandAerial },
      { id: "island-aerial-jpg", label: "Island aerial (alt)", url: islandAerialJpg },
      { id: "island-cabanas", label: "Island cabanas", url: islandCabanas },
    ],
  },
  {
    group: "Paddle boarding pictures",
    images: [
      { id: "paddle-hero", label: "Paddleboard hero", url: paddleHero },
      { id: "paddle-swim", label: "Paddleboarding & swimming", url: paddleSwim },
      { id: "paddle-geronimo", label: "Paddleboard at Geronimo", url: paddleGeronimo },
    ],
  },
  {
    group: "Kayaking pictures",
    images: [
      { id: "kayak-main", label: "Kayaking", url: kayaking },
      { id: "kayak-river", label: "Kayak river", url: kayakRiver },
      { id: "kayak-geronimo", label: "Kayak at Geronimo", url: kayakGeronimo },
    ],
  },
];

export const DEFAULT_POPUP_IMAGE_ID = "island-aerial-webp";

export function getPopupImageUrlById(id: string | null | undefined): string {
  for (const g of POPUP_IMAGE_GROUPS) {
    for (const img of g.images) {
      if (img.id === id) return img.url;
    }
  }
  const fallback = POPUP_IMAGE_GROUPS[0].images.find((i) => i.id === DEFAULT_POPUP_IMAGE_ID);
  return fallback?.url ?? POPUP_IMAGE_GROUPS[1].images[0].url;
}